// extracted by mini-css-extract-plugin
export default {"content":"TambahUmkm_content__7yV8L","main":"TambahUmkm_main__l59+V","form":"TambahUmkm_form__siI01","preview":"TambahUmkm_preview__k3h42"};